(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_37e7076"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'boker-advent-calendar-v4';
  if (customElements.get(tag)) return;

  class BokerAdventCSV extends HTMLElement {
    constructor() {
      super();
      this.days = new Map();
      this.dataLoaded = false;
      this.timer = null;
      this.visibilityTimer = null;
      this.lastFocus = null;
      this.memoryProgress = [];
      this.handleDocumentKey = this.handleDocumentKey.bind(this);
    }

    get lang() { return String(this.dataset.shopLocale || 'de').toLowerCase() === 'en' ? 'en' : 'de'; }
    get year() { return Number(this.dataset.calendarYear) || new Date().getFullYear(); }
    // Server-rendered editor flag is authoritative; no dependency on script loading order.
    get isEditor() { return this.dataset.designMode === 'true'; }
    get testMode() { return this.isEditor && this.dataset.testMode === 'true'; }
    get testView() { return this.dataset.testView === 'date' ? 'date' : 'all'; }
    get preview() { return this.testMode && this.testView === 'date' ? Math.max(0, Math.min(24, Number(this.dataset.previewDay) || 0)) : 0; }
    get testHour() { const n = Number(this.dataset.testHour); return Number.isFinite(n) ? Math.max(0, Math.min(23, n)) : 12; }
    get includeInactive() { return this.testMode && this.dataset.testInactive === 'true'; }
    get root() { const s = this.dataset.rootUrl || '/'; return s.endsWith('/') ? s : s + '/'; }
    get cl() { return this.dataset.cssPrefix || ''; }
    get labels() {
      const de = {
        open:'Türchen öffnen',locked:'Öffnet am',opened:'Geöffnet',day:'Türchen',close:'Schließen',
        progress:'Dein Sammelfortschritt',progressEnd:'von 24 Türchen geöffnet',
        started:'Der Adventskalender startet am 1. Dezember.',
        loading:'Kalenderinhalte werden geladen …',fail:'Die Kalenderinhalte konnten nicht geladen werden. Bitte prüfe die CSV-Datei und den Dateinamen.',
        missing:'Diese Überraschung ist noch nicht verfügbar.',
        code:'Dein Rabattcode',copy:'Code kopieren',copied:'Kopiert!',redeem:'Code einlösen',
        gift:'Gratisartikel hinzufügen & Code aktivieren',choose:'Variante auswählen',soldout:'Nicht verfügbar',
        giftwait:'Geschenk wird hinzugefügt …',gifterror:'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.',
        giftmissing:'Für dieses Geschenk fehlen Rabattcode oder Produkt-Handle/Varianten-ID.',
        disclaimer:'Es gelten die in Shopify eingerichteten Rabattbedingungen.',
        quiz:'Quizfrage',check:'Antwort prüfen',correct:'Richtig! Hier ist deine Belohnung.',
        wrong:'Leider nicht richtig. Versuche es erneut.',select:'Bitte wähle eine Antwort aus.',
        dealend:'Angebot endet in',expired:'Dieses 24-Stunden-Angebot ist abgelaufen.',
        name:'Dein Name',email:'Deine E-Mail-Adresse',giveaway:'Am Gewinnspiel teilnehmen',
        terms:'Ich akzeptiere die Teilnahmebedingungen und habe die Datenschutzerklärung gelesen.',
        termslink:'Teilnahmebedingungen',privacy:'Datenschutzerklärung',
        giveawaymissing:'Bitte Teilnahmebedingungen und ein Teilnahmeformular hinterlegen.',
        noNewsletter:'Eine Teilnahme ist keine Newsletter-Anmeldung.',
        countdownDone:'00:00:00',noVideo:'Für dieses Türchen ist noch kein Video hinterlegt.',
        testTitle:'Testmodus aktiv · Nur im Theme-Editor',
        testAll:'Alle 24 Türchen sind zum Testen freigeschaltet. Jeder Deal startet in der Vorschau an seinem eigenen Aktionstag.',
        testDate:'Simulierte Zeit (Europe/Berlin): ',testHourLabel:'Startzeit je Deal: ',
        testInactiveOn:'Inaktive CSV-Zeilen werden als Entwurf angezeigt.',
        testInactiveOff:'Es werden nur CSV-Zeilen mit active = 1 angezeigt.',
        testSafety:'Nur Anzeigevorschau: Links, Warenkorbaktionen, Rabatt-Einlösung und Gewinnspielversand sind hier blockiert. Die Gültigkeit der Codes wird nicht geprüft.',
        testReset:'Testfortschritt zurücksetzen',testReload:'CSV neu laden',
        testResetDone:'Der Vorschau-Fortschritt wurde zurückgesetzt. Der Live-Fortschritt bleibt unverändert.',
        testDraft:'Entwurf: Diese CSV-Zeile ist inaktiv. Sie wird nur in dieser Testvorschau angezeigt.',
        testEmpty:'Noch keine Inhalte für diese ID hinterlegt. Bitte das entsprechende Türchen in Excel befüllen und die CSV erneut hochladen.',
        testRowMissing:'Für diese Türchen-ID fehlt eine Zeile in der CSV.',
        testInactiveMissing:'Diese CSV-Zeile ist inaktiv. Aktiviere im Testmodus die Einstellung „Inaktive CSV-Zeilen mit anzeigen“, um sie zu prüfen.',
        testAction:'Nur Vorschau: Dieser Link wird im Testmodus nicht geöffnet. Es wird kein Rabatt eingelöst.',
        testGift:'Vorschau geprüft: Der Klick würde den Gratisartikel hinzufügen und den Code aktivieren. Es wurde nichts geändert; Rabattbedingungen wurden nicht geprüft.',
        testSubmit:'Formularvorschau geprüft. Es wurde keine Teilnahme versendet.',
        unavailable:'Nicht mehr verfügbar',testReadOnly:'Anzeigevorschau – keine Live-Aktion'
      };
      const en = {
        open:'Open door',locked:'Opens on',opened:'Opened',day:'Door',close:'Close',
        progress:'Your collection progress',progressEnd:'of 24 doors opened',
        started:'The Advent calendar starts on 1 December.',
        loading:'Loading calendar content …',fail:'Calendar content could not be loaded. Check the CSV file and filename.',
        missing:'This surprise is not yet available.',
        code:'Your discount code',copy:'Copy code',copied:'Copied!',redeem:'Redeem code',
        gift:'Add free gift & apply code',choose:'Choose variant',soldout:'Unavailable',
        giftwait:'Adding your gift …',gifterror:'Could not add the item. Please try again.',
        giftmissing:'Gift is missing a discount code or product handle/variant ID.',
        disclaimer:'Discounts are subject to the conditions configured in Shopify.',
        quiz:'Quiz question',check:'Check answer',correct:'Correct! Here is your reward.',
        wrong:'Not quite right. Try again.',select:'Please select an answer.',
        dealend:'Offer ends in',expired:'This 24-hour offer has expired.',
        name:'Your name',email:'Your email',giveaway:'Enter giveaway',
        terms:'I accept the giveaway terms and have read the privacy policy.',
        termslink:'Giveaway terms',privacy:'Privacy policy',
        giveawaymissing:'Please add giveaway terms and a form.',
        noNewsletter:'Entering does not subscribe you to marketing emails.',
        countdownDone:'00:00:00',noVideo:'There is no video for this door yet.',
        testTitle:'Test mode active · Theme editor only',
        testAll:'All 24 doors are unlocked for testing. Each deal preview starts on its own offer date.',
        testDate:'Simulated time (Europe/Berlin): ',testHourLabel:'Start time for each deal: ',
        testInactiveOn:'Inactive CSV rows are shown as drafts.',testInactiveOff:'Only CSV rows with active = 1 are shown.',
        testSafety:'Display preview only: links, cart actions, discount redemption and giveaway submissions are blocked. Discount validity is not checked.',
        testReset:'Reset test progress',testReload:'Reload CSV',
        testResetDone:'Preview progress has been reset. Live progress is unchanged.',
        testDraft:'Draft: this CSV row is inactive and visible only in this test preview.',
        testEmpty:'There is no content for this ID yet. Fill in the matching Excel row and upload the CSV again.',
        testRowMissing:'The CSV has no row for this door ID.',
        testInactiveMissing:'This CSV row is inactive. Enable the option to include inactive CSV rows in test mode to preview it.',
        testAction:'Preview only: this link will not open in test mode. No discount has been applied.',
        testGift:'Preview checked: this button would add the gift and activate the code. Nothing was changed and discount conditions were not checked.',
        testSubmit:'Form preview checked. No entry was submitted.',
        unavailable:'No longer available',testReadOnly:'Display preview – no live action'
      };
      return this.lang === 'en' ? en : de;
    }

    static get observedAttributes() {
      return ['data-csv-url','data-calendar-year','data-preview-day','data-test-mode',
        'data-test-view','data-test-hour','data-test-inactive','data-order','data-keep-past',
        'data-shop-locale','data-calendar-key','data-root-url','data-design-mode',
        'data-default-cta','data-door-mode','data-csv-door-images','data-door-image-url'];
    }
    connectedCallback() {
      this.contentObserver?.disconnect();
      this.contentObserver = new MutationObserver(() => {
        if (!this.initialized || this.grid !== this.querySelector('[data-grid]') ||
            this.closeButton !== this.querySelector('[data-close]')) this.queueInitialize();
      });
      this.contentObserver.observe(this,{childList:true,subtree:true});
      this.queueInitialize();
    }
    attributeChangedCallback(name, before, after) {
      if (before !== after && this.isConnected) this.queueInitialize(true);
    }
    queueInitialize(force = false) {
      this.restartRequested = this.restartRequested || force;
      if (this.initQueued) return;
      this.initQueued = true;
      queueMicrotask(() => {
        this.initQueued = false;
        if (!this.isConnected) return;
        const grid = this.querySelector('[data-grid]');
        const ready = this.querySelector('[data-advent-ready]');
        if (!ready || !grid || grid.querySelectorAll('[data-day]').length !== 24 ||
            !this.querySelector('[data-overlay]') || !this.querySelector('[data-close]')) return;
        if (this.initialized && !this.restartRequested && this.grid === grid) return;
        this.restartRequested = false;
        this.cleanupRuntime();
        try { this.initializeCalendar(); }
        catch (error) {
          this.cleanupRuntime();
          this.dataset.runtimeReady = 'error';
          console.error('Boker Advent initialization:',error);
          const message = this.querySelector('[data-message]');
          if (message) {
            message.hidden = false;
            message.textContent = this.isEditor
              ? 'Kalender konnte nicht starten: '+error.message+' Bitte Theme-Editor neu laden.'
              : this.labels.fail;
          }
        }
      });
    }
    initializeCalendar() {
      this.events = new AbortController();
      this.previewEpoch = performance.now();
      this.grid = this.querySelector('[data-grid]');
      this.overlay = this.querySelector('[data-overlay]');
      this.modalContent = this.querySelector('[data-modal-content]');
      this.message = this.querySelector('[data-message]');
      this.closeButton = this.querySelector('[data-close]');
      this.closeButton.setAttribute('aria-label',this.labels.close);
      this.querySelector('[data-progress-label]')?.replaceChildren(document.createTextNode(this.labels.progress));
      this.initialized = true;
      const options = {signal:this.events.signal};
      this.grid.addEventListener('click', e => {
        const door = e.target.closest('[data-day]');
        if (door && this.grid.contains(door)) this.openDay(Number(door.dataset.day),door);
      },options);
      this.closeButton.addEventListener('click',()=>this.close(),options);
      this.overlay.addEventListener('click',e=>{if(e.target===this.overlay)this.close();},options);
      this.addEventListener('click',e=>this.guardTestLink(e),{capture:true,signal:this.events.signal});
      this.addEventListener('auxclick',e=>this.guardTestLink(e),{capture:true,signal:this.events.signal});
      this.addEventListener('submit',e=>{
        if(!this.testMode)return;
        e.preventDefault();e.stopImmediatePropagation();this.testNotice(this.labels.testSubmit);
      },{capture:true,signal:this.events.signal});
      this.setupTestPanel();
      this.shuffle();this.applyDoorCovers();this.refreshDoors();this.refreshProgress();
      this.visibilityTimer=window.setInterval(()=>this.refreshDoors(),this.testMode?1000:30000);
      this.dataset.runtimeReady='true';
      this.loadFile();
    }
    cleanupRuntime() {
      this.initialized=false;
      this.events?.abort();this.fileController?.abort();
      if(this.timer)clearInterval(this.timer);
      if(this.visibilityTimer)clearInterval(this.visibilityTimer);
      this.timer=null;this.visibilityTimer=null;
      this.overlay?.removeAttribute('open');this.overlay?.setAttribute('aria-hidden','true');
      this.modalContent?.replaceChildren();
      document.removeEventListener('keydown',this.handleDocumentKey);
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();this.cleanupRuntime();
    }
    setupTestPanel() {
      const panel = this.querySelector('[data-editor-panel]');
      if (!panel) return;
      panel.hidden = !this.isEditor;
      if (!this.isEditor) return;
      panel.querySelector('[data-editor-title]').textContent = this.testMode ? this.labels.testTitle :
        (this.lang==='en'?'Theme editor · Live date active':'Theme-Editor · Echte Zeit aktiv');
      panel.querySelector('[data-editor-safety]').textContent = this.testMode ? this.labels.testSafety :
        (this.lang==='en'?'Set a preview day or enable test mode to test safely.':'Zum sicheren Testen einen Vorschau-Tag einstellen oder den Testmodus aktivieren.');
      panel.querySelector('[data-csv-source]').textContent = this.dataset.csvUrl || '—';
      const reset = panel.querySelector('[data-reset-preview]');
      reset.hidden = !this.testMode;
      reset.textContent = this.labels.testReset;
      reset.addEventListener('click', () => {
        if (!this.testMode) return;
        this.close();this.memoryProgress = [];
        this.write(this.dataset.calendarKey + ':opened', []);
        this.refreshProgress();this.refreshDoors();
        panel.querySelector('[data-editor-feedback]').textContent = this.labels.testResetDone;
      }, {signal:this.events.signal});
      const reload = panel.querySelector('[data-reload-preview]');
      reload.textContent = this.labels.testReload;
      reload.addEventListener('click', () => {
        if (!this.isEditor) return;
        this.close();this.loadFile();
      }, {signal:this.events.signal});
      this.updateTestPanel();
    }
    updateTestPanel() {
      const description = this.querySelector('[data-editor-description]');
      if (!description) return;
      if (!this.testMode) {description.textContent='';return;}
      const stamp = new Intl.DateTimeFormat(this.lang === 'en' ? 'en-GB' : 'de-DE', {
        timeZone:'Europe/Berlin',day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'
      }).format(new Date(this.now()));
      description.textContent = (this.testView === 'all'
        ? this.labels.testAll + ' ' + this.labels.testHourLabel + String(this.testHour).padStart(2,'0') + ':00.'
        : this.labels.testDate + stamp + '.')
        + ' ' + (this.includeInactive ? this.labels.testInactiveOn : this.labels.testInactiveOff);
    }
    testNotice(text) {
      if (!this.testMode) return;
      let note = this.modalContent.querySelector('[data-test-notice]');
      if (!note) {
        note = this.node('p','editor-note');note.dataset.testNotice = '';note.setAttribute('role','status');
        this.modalContent.appendChild(note);
      }
      note.textContent = text;
    }
    guardTestLink(event) {
      if (!this.testMode || !event.target.closest('a[href]')) return;
      event.preventDefault();event.stopImmediatePropagation();
      if (this.overlay.hasAttribute('open')) this.testNotice(this.labels.testAction);
      else this.querySelector('[data-editor-feedback]')?.replaceChildren(document.createTextNode(this.labels.testAction));
    }
    now() {
      if (!this.testMode || this.testView !== 'date') return Date.now();
      // December in Berlin is UTC+1. Day 0 deliberately means 30 November.
      return Date.UTC(this.year,11,this.preview,this.testHour-1,0,0) + (performance.now()-this.previewEpoch);
    }
    node(tag, cls, text) {
      const el = document.createElement(tag);
      if (cls) el.className = cls.split(/\s+/).filter(Boolean).map(c=>c.startsWith('is-')||c.startsWith(this.cl)?c:this.cl+c).join(' ');
      if (text !== undefined) el.textContent = text;
      return el;
    }
    safeURL(raw) {
      if (!raw) return null;
      try {
        const u = new URL(String(raw).trim(), location.href);
        return (u.protocol === 'https:' || u.protocol === 'http:') ? u.href : null;
      } catch (_err) { return null; }
    }
    fetchPath(path) { return this.root + String(path).replace(/^\/+/, ''); }
    localized(row, name) { return row[name + '_' + this.lang] || row[name + '_de'] || row[name + '_en'] || ''; }
    read(key, fallback) { try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (_err) { return fallback; } }
    write(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_err) { /* no storage available */ } }
    shuffle() {
      const nodes = [...this.grid.querySelectorAll('[data-day]')];
      let order = [14,3,21,8,17,1,24,10,5,19,12,7,23,2,16,11,4,20,9,22,6,15,18,13];
      if (this.dataset.order === 'ordered') order = Array.from({length:24},(_,i)=>i+1);
      if (this.dataset.order === 'random_once') {
        const key = this.dataset.calendarKey + ':door-order';
        const saved = this.read(key, []);
        if (Array.isArray(saved) && saved.length === 24 && new Set(saved).size === 24 && saved.every(n => Number.isInteger(n) && n > 0 && n < 25)) order = saved;
        else {
          order = Array.from({length:24}, (_, i) => i + 1);
          for (let i=23;i>0;i--) { const j = Math.floor(Math.random()*(i+1)); [order[i],order[j]]=[order[j],order[i]]; }
          this.write(key, order);
        }
      }
      const map = new Map(nodes.map(el => [Number(el.dataset.day),el]));
      order.forEach(day => { if (map.has(day)) this.grid.appendChild(map.get(day)); });
    }
    applyDoorCovers() {
      // Public artwork only: never fall back to image_url, which belongs inside the popup.
      const shared = this.safeURL(this.dataset.doorImageUrl);
      const fromCSV = this.dataset.csvDoorImages === 'true';
      for (const button of this.grid.querySelectorAll('[data-day]')) {
        const image = button.querySelector('[data-door-cover]');
        if (!image) continue;
        const row = this.days.get(Number(button.dataset.day));
        const individual = fromCSV && row ? this.safeURL(row.door_image_url) : null;
        const source = individual || shared;
        if (!source) {
          image.onload = null;image.onerror = null;image.removeAttribute('src');image.hidden = true;
          button.classList.remove('has-image');continue;
        }
        image.onload = () => {image.hidden = false;button.classList.add('has-image');};
        image.onerror = () => {image.hidden = true;button.classList.remove('has-image');};
        if (image.getAttribute('src') !== source) image.src = source;
        // Keep the overlay in place during lazy loading; broken images fall back to the base colour.
        image.hidden = false;button.classList.add('has-image');
        if (image.complete && image.naturalWidth === 0) {image.hidden = true;button.classList.remove('has-image');}
      }
    }
    clock() {
      const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date(this.now()));
      const value = (name) => Number(parts.find(p => p.type === name)?.value || 0);
      return {year:value('year'),month:value('month'),day:value('day')};
    }
    currentDay() {
      const time = this.clock();
      if (time.year > this.year) return 24;
      if (time.year < this.year || time.month < 12) return 0;
      return Math.min(time.day, 24);
    }
    canOpen(day) {
      if (!Number.isInteger(day) || day < 1 || day > 24) return false;
      if (this.testMode && this.testView === 'all') return true;
      const today = this.currentDay();
      return today >= day && today > 0 && (this.dataset.keepPast === 'true' || this.todayIs(day));
    }
    todayIs(day) {
      if (this.testMode && this.testView === 'all') return false;
      const t = this.clock();return t.year === this.year && t.month === 12 && t.day === day;
    }
    refreshDoors() {
      for (const btn of this.grid.querySelectorAll('[data-day]')) {
        const day = Number(btn.dataset.day); const unlocked = this.canOpen(day);
        btn.classList.toggle('is-locked', !unlocked);
        btn.classList.toggle('is-today', this.todayIs(day));
        btn.dataset.unlocked = unlocked ? 'true' : 'false';
        const lockedLabel = this.currentDay() >= day ? this.labels.unavailable : this.labels.locked + ' ' + day + '.12.';
        btn.setAttribute('aria-label', this.labels.day + ' ' + day + ': ' + (unlocked ? this.labels.open : lockedLabel));
        const caption = btn.querySelector('[data-caption]');
        caption.textContent = unlocked ? (this.getProgress().includes(day) ? this.labels.opened : this.labels.open) : lockedLabel;
      }
      this.updateTestPanel();
    }
    getProgress() {
      const v = this.read(this.dataset.calendarKey + ':opened', this.memoryProgress);
      return Array.isArray(v) ? [...new Set(v.filter(x => Number.isInteger(x) && x >= 1 && x <= 24))] : [];
    }
    visit(day) {
      const list = [...new Set([...this.getProgress(),day])];
      this.memoryProgress = list; this.write(this.dataset.calendarKey + ':opened', list);
      this.refreshProgress();this.refreshDoors();
    }
    refreshProgress() {
      const list = this.getProgress();
      for (const btn of this.grid.querySelectorAll('[data-day]')) btn.classList.toggle('is-visited', list.includes(Number(btn.dataset.day)));
      const text = this.querySelector('[data-progress-text]');
      if (text) text.textContent = list.length + ' ' + this.labels.progressEnd;
      const bar = this.querySelector('[data-progress-bar]');
      if (bar) bar.setAttribute('aria-valuenow', String(list.length));
      const fill = this.querySelector('[data-progress-fill]');
      if (fill) fill.style.width = (list.length / 24 * 100).toFixed(2) + '%';
    }

    csvError(de,en) {return new Error(this.lang==='en'?en:de);}
    parseCSV(text) {
      let raw=String(text).replace(/^\uFEFF/,'').replace(/^(?:[ \t]*\r?\n)+/,'');
      const sepLine=raw.match(/^sep=([;,\t])\r?\n/i);
      let delimiter=sepLine?.[1];
      if(sepLine)raw=raw.slice(sepLine[0].length);
      if(!delimiter){
        const first=raw.split(/\r?\n/,1)[0];
        delimiter=[';',',','\t'].map(sep=>({sep,n:first.split(sep).length})).sort((a,b)=>b.n-a.n)[0].sep;
      }
      if(/^\s*(?:<!doctype|<html|<\?xml)/i.test(raw))throw this.csvError(
        'Die Adresse liefert eine Webseite statt CSV. Den direkten Dateilink aus Inhalte > Dateien verwenden.',
        'This address returns a webpage, not CSV. Use the direct link from Content > Files.');
      const records=[];let record=[],value='',quoted=false;
      for(let i=0;i<raw.length;i++){
        const ch=raw[i];
        if(quoted){
          if(ch==='"'&&raw[i+1]==='"'){value+='"';i++;}
          else if(ch==='"')quoted=false;
          else value+=ch;
        }else if(ch==='"' && value===''){quoted=true;}
        else if(ch===delimiter){record.push(value);value='';}
        else if(ch==='\r'||ch==='\n'){
          if(ch==='\r'&&raw[i+1]==='\n')i++;
          record.push(value);value='';
          if(record.some(cell=>cell.trim()))records.push(record);
          record=[];
        }else value+=ch;
      }
      record.push(value);if(record.some(cell=>cell.trim()))records.push(record);
      if(quoted)throw this.csvError('CSV: Ein Anf\u00fchrungszeichen wurde nicht geschlossen.','CSV: an opening quote is not closed.');
      if(!records.length)throw this.csvError('Die CSV ist leer.','The CSV is empty.');
      const head=records.shift().map(v=>v.trim().toLowerCase());
      const required=['id','type','active'].filter(key=>!head.includes(key));
      if(required.length)throw this.csvError('Fehlende CSV-Spalten: '+required.join(', ')+'. Das Blatt Kalenderdaten exportieren.',
        'Missing CSV columns: '+required.join(', ')+'. Export the Kalenderdaten sheet.');
      const named=head.filter(Boolean);
      if(new Set(named).size!==named.length)throw this.csvError('Doppelte Spaltennamen in der CSV.','Duplicate CSV column names.');
      return records.map((parts,index)=>{
        if(parts.slice(head.length).some(cell=>cell.trim()))throw this.csvError(
          'CSV-Datensatz '+(index+2)+': mehr Werte als Spalten. Bitte erneut als CSV exportieren.',
          'CSV record '+(index+2)+': more values than columns. Please re-export CSV.');
        return Object.fromEntries(head.map((name,i)=>[name,(parts[i]||'').trim()]).filter(([name])=>name));
      });
    }
    async fetchCSV(url,signal) {
      const request=new AbortController();
      const abort=()=>request.abort();
      if(signal.aborted)request.abort();
      signal.addEventListener('abort',abort,{once:true});
      const timer=setTimeout(()=>request.abort(),12000);
      try{
        const response=await fetch(url,{credentials:new URL(url).origin===location.origin?'same-origin':'omit',
          cache:'no-store',signal:request.signal});
        if(!response.ok)throw this.csvError('Datei nicht abrufbar (HTTP '+response.status+').','File request failed (HTTP '+response.status+').');
        const bytes=new Uint8Array(await response.arrayBuffer());
        if(bytes[0]===0x50&&bytes[1]===0x4b)throw this.csvError(
          'Das ist eine Excel-/ZIP-Datei. Bitte das Blatt Kalenderdaten als CSV UTF-8 exportieren.',
          'This is an Excel/ZIP file. Export the Kalenderdaten sheet as CSV UTF-8.');
        let encoding='utf-8';
        if(bytes[0]===0xff&&bytes[1]===0xfe)encoding='utf-16le';
        else if(bytes[0]===0xfe&&bytes[1]===0xff)encoding='utf-16be';
        let text;
        try{text=new TextDecoder(encoding,{fatal:true}).decode(bytes);}
        catch(_err){throw this.csvError('Dateikodierung unlesbar. Bitte CSV UTF-8 verwenden.','Unsupported encoding. Please use CSV UTF-8.');}
        return this.parseCSV(text);
      }finally{clearTimeout(timer);signal.removeEventListener('abort',abort);}
    }
    updateCSVStatus(text,isError=false) {
      const status=this.querySelector('[data-csv-status]');
      if(status){status.textContent=text;status.style.fontWeight=isError?'700':'';}
      const source=this.querySelector('[data-csv-source]');
      if(source)source.textContent=this.loadedCSVURL || this.dataset.csvUrl || '\u2014';
    }
    async loadFile() {
      this.fileController?.abort();
      const controller=new AbortController();this.fileController=controller;
      this.dataLoaded=false;this.loadState='loading';this.days.clear();this.loadedCSVURL='';
      this.applyDoorCovers();this.setMessage(this.labels.loading,false);this.updateCSVStatus(this.labels.loading);
      const source=this.safeURL(this.dataset.csvUrl);
      try{
        if(!source)throw this.csvError('Keine g\u00fcltige CSV-Adresse hinterlegt.','No valid CSV address is configured.');
        const original=new URL(source);const candidates=[original.href];
        // Use the exact file link first. Same-origin /cdn is a fallback, not a mandatory rewrite.
        if(original.pathname.startsWith('/cdn/shop/files/')&&original.origin!==location.origin){
          candidates.push(location.origin+original.pathname+original.search);
        }
        let records=null,lastError=null;
        for(const url of candidates){
          if(controller.signal.aborted)return;
          try{records=await this.fetchCSV(url,controller.signal);this.loadedCSVURL=url;break;}
          catch(error){if(controller.signal.aborted)return;lastError=error;}
        }
        if(!records)throw lastError || new Error('CSV request failed');
        if(controller.signal.aborted||!this.isConnected)return;
        const days=new Map();
        for(const row of records){
          const day=Number(row.id);
          if(!Number.isInteger(day)||day<1||day>24)throw this.csvError(
            'Ung\u00fcltige T\u00fcrchen-ID: '+String(row.id).slice(0,40)+'. Erlaubt sind 1 bis 24.',
            'Invalid door ID: '+String(row.id).slice(0,40)+'. Use 1 to 24.');
          if(days.has(day))throw this.csvError('Doppelte T\u00fcrchen-ID: '+day+'.','Duplicate door ID: '+day+'.');
          days.set(day,row);
        }
        if(!days.size)throw this.csvError('Die CSV enth\u00e4lt keine T\u00fcrchen.','The CSV contains no doors.');
        this.days=days;this.dataLoaded=true;this.loadState='ready';
        this.applyDoorCovers();this.refreshDoors();this.setMessage('',false);
        const active=[...days.values()].filter(row=>this.rowIsActive(row)).length;
        this.updateCSVStatus(this.lang==='en'
          ?'CSV loaded: '+days.size+' of 24 doors \u00b7 '+active+' active.'
          :'CSV geladen: '+days.size+' von 24 T\u00fcrchen \u00b7 '+active+' aktiv.');
        if(this.isEditor&&days.size!==24)this.setMessage(this.lang==='en'?'Some door IDs are missing.':'Einige T\u00fcrchen-IDs fehlen in der CSV.',true);
      }catch(error){
        if(controller.signal.aborted)return;
        this.dataLoaded=false;this.loadState='error';this.days.clear();
        this.applyDoorCovers();console.error('Boker Advent CSV:',error);
        const detail=error.name==='AbortError'
          ?(this.lang==='en'?'Request timed out. Check the file link.':'Zeit\u00fcberschreitung beim Laden. Bitte den Dateilink pr\u00fcfen.')
          :String(error.message || error).slice(0,320);
        this.setMessage(this.isEditor?this.labels.fail+' '+detail:this.labels.fail,true);
        this.updateCSVStatus((this.lang==='en'?'CSV error: ':'CSV-Fehler: ')+detail,true);
      }
    }
    setMessage(value,isError) {
      this.message.hidden = !value;
      this.message.textContent = value;
      this.message.classList.toggle('is-error', Boolean(isError));
    }
    rowIsActive(row) { return Boolean(row && ['1','true','ja','yes','aktiv'].includes(String(row.active).trim().toLowerCase())); }
    activeRow(day) {
      const row = this.days.get(day);
      return row && (this.rowIsActive(row) || this.includeInactive) ? row : null;
    }
    rowHasContent(row) {
      return ['title_de','title_en','text_de','text_en','image_url','link_url','discount_code','question_de','question_en','video_url','giveaway_form_url'].some(key => String(row[key] || '').trim());
    }
    openDay(day, focus) {
      if (this.timer) {clearInterval(this.timer);this.timer=null;}
      this.lastFocus = focus || this.grid.querySelector('[data-day="'+day+'"]');
      this.querySelector('[data-modal-day]').textContent = this.labels.day + ' ' + day;
      const title = this.querySelector('[data-modal-title]');
      const body = this.modalContent;
      body.replaceChildren();
      if (!this.canOpen(day)) {
        title.textContent = this.currentDay() >= day ? this.labels.unavailable : this.labels.locked + ' ' + day + '.12.' + this.year;
        body.appendChild(this.node('p','body',this.labels.missing));
      } else if (!this.dataLoaded) {
        title.textContent = this.labels.day + ' ' + day;
        body.appendChild(this.node('p','body',this.loadState==='loading'?this.labels.loading:this.labels.fail));
      } else {
        const row = this.activeRow(day);
        title.textContent = row ? (this.localized(row,'title') || this.labels.day+' '+day) : this.labels.day+' '+day;
        if (row) {
          if (this.testMode) {
            body.appendChild(this.node('p','editor-note',this.rowIsActive(row) ? this.labels.testReadOnly : this.labels.testDraft));
            if (!this.rowHasContent(row)) body.appendChild(this.node('p','editor-note',this.labels.testEmpty));
          }
          this.render(row,day,body);this.visit(day);
        } else {
          const message = this.testMode ? (this.days.has(day) ? this.labels.testInactiveMissing : this.labels.testRowMissing) : this.labels.missing;
          body.appendChild(this.node('p','body',message));
        }
      }
      this.overlay.setAttribute('open','');
      this.overlay.setAttribute('aria-hidden','false');
      document.addEventListener('keydown',this.handleDocumentKey);
      this.closeButton.focus();
    }
    close() {
      if (this.timer) {clearInterval(this.timer);this.timer=null;}
      this.overlay.removeAttribute('open');
      this.overlay.setAttribute('aria-hidden','true');
      document.removeEventListener('keydown',this.handleDocumentKey);
      this.modalContent.replaceChildren();
      if (this.lastFocus?.isConnected) this.lastFocus.focus();
    }
    handleDocumentKey(evt) {
      if (!this.overlay.hasAttribute('open')) return;
      if (evt.key === 'Escape') {evt.preventDefault();this.close();return;}
      if (evt.key !== 'Tab') return;
      const elems = [...this.overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled])')].filter(el=>!el.hidden && el.getClientRects().length);
      if (!elems.length) return;
      const first=elems[0],last=elems[elems.length-1];
      if (evt.shiftKey && document.activeElement === first){evt.preventDefault();last.focus();}
      if (!evt.shiftKey && document.activeElement === last){evt.preventDefault();first.focus();}
    }
    addText(container,value) { if(value) container.appendChild(this.node('div','body',value)); }
    addImage(container,url,title) {
      const src=this.safeURL(url);if(!src) return;
      const img=this.node('img','image');img.src=src;img.alt=title || '';img.loading='lazy';container.appendChild(img);
    }
    button(text,action,subtle=false) {
      const btn=this.node('button','button'+(subtle?' '+this.cl+'button--outline':''),text);
      btn.type='button';btn.addEventListener('click',action);return btn;
    }
    link(text,url) {
      const href=this.safeURL(url);if(!href)return null;
      const a=this.node('a','button',text || this.dataset.defaultCta || this.labels.open);
      a.href=this.testMode ? '#' : href;return a;
    }
    group(container) {const div=this.node('div','actions');container.appendChild(div);return div;}
    addLink(container,row) {
      const link=this.link(this.localized(row,'button') || this.dataset.defaultCta || this.labels.open, row.link_url);
      if(link)this.group(container).appendChild(link);
    }
    codeArea(container,code) {
      if (!code) return;
      container.appendChild(this.node('div','label',this.labels.code));
      container.appendChild(this.node('span','code',code));
      const buttons=this.group(container);
      buttons.appendChild(this.button(this.labels.copy,async e=>{
        try {await navigator.clipboard.writeText(code);e.target.textContent=this.labels.copied;}
        catch(_err){const field=this.node('input','field');field.value=code;buttons.appendChild(field);field.focus();field.select();}
      },true));
      return buttons;
    }
    redeemURL(code) {return this.fetchPath('discount/'+encodeURIComponent(code))+'?redirect='+encodeURIComponent(this.fetchPath('cart'));}
    promoArea(container,code,redirect=true) {
      if (!code) return;
      const buttons=this.codeArea(container,code);
      if (redirect && buttons) {const a=this.link(this.labels.redeem,this.redeemURL(code));if(a)buttons.appendChild(a);}
      container.appendChild(this.node('p','status',this.labels.disclaimer));
    }
    render(row,day,body) {
      const type=String(row.type || 'content').toLowerCase();
      const title=this.localized(row,'title') || this.labels.day+' '+day;
      this.addImage(body,row.image_url,title);
      this.addText(body,this.localized(row,'text'));
      if (type === 'gift') this.gift(row,body);
      else if (type === 'discount') this.promoArea(body,row.discount_code);
      else if (type === 'quiz') this.quiz(row,body,day);
      else if (type === 'deal') this.deal(row,body,day);
      else if (type === 'video') this.video(row,body);
      else if (type === 'giveaway') this.giveaway(row,body,day);
      else this.addLink(body,row);
    }
    async gift(row,body) {
      const code=String(row.discount_code||'').trim();
      const handle=String(row.product_handle||'').trim().toLowerCase();
      let selected=String(row.variant_id||'').trim();
      if (!code || (!/^\d+$/.test(selected) && !/^[a-z0-9][a-z0-9-]*$/.test(handle))) {
        body.appendChild(this.node('p','status is-error',this.labels.giftmissing));return;
      }
      const info=this.node('div');body.appendChild(info);
      const status=this.node('p','status');body.appendChild(status);
      const buttons=this.codeArea(body,code);
      let select=null;
      if (/^[a-z0-9][a-z0-9-]*$/.test(handle)) {
        try {
          const response=await fetch(this.fetchPath('products/'+handle+'.js'),{credentials:'same-origin'});
          if(!response.ok)throw new Error('Product unavailable');
          const product=await response.json();
          if (product.variants?.length) {
            const available=product.variants.filter(v=>v.available);
            if (!selected) selected=String(available[0]?.id || '');
            if (product.variants.length>1 && !row.variant_id) {
              info.appendChild(this.node('label','label',this.labels.choose));
              select=this.node('select','field');
              for(const v of product.variants){
                const op=document.createElement('option');op.value=String(v.id);op.textContent=v.title + (v.available?'':' — '+this.labels.soldout);
                op.disabled=!v.available;if(op.value===selected)op.selected=true;select.appendChild(op);
              }
              info.appendChild(select);
            }
          }
        }catch(err){console.warn('Boker gift product:',err);}
      }
      const add=this.button(this.labels.gift,async()=>{
        const variant=select?select.value:selected;
        if(!/^\d+$/.test(variant)){status.textContent=this.labels.giftmissing;status.classList.add('is-error');return;}
        if (this.testMode) {status.classList.remove('is-error');status.textContent=this.labels.testGift;return;}
        add.disabled=true;status.classList.remove('is-error');status.textContent=this.labels.giftwait;
        try {
          const cartResponse=await fetch(this.fetchPath('cart.js'),{credentials:'same-origin'});
          if(!cartResponse.ok)throw new Error('Cart read failed');
          const cart=await cartResponse.json();
          const alreadyInCart=(cart.items||[]).some(item=>String(item.variant_id)===variant && item.quantity>0);
          if(!alreadyInCart){
            const response=await fetch(this.fetchPath('cart/add.js'),{
              method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
              body:JSON.stringify({items:[{id:Number(variant),quantity:1}]})
            });
            if(!response.ok)throw new Error('Add to cart failed');
          }
          location.assign(this.redeemURL(code));
        }catch(err){console.error('Boker gift:',err);status.textContent=this.labels.gifterror;status.classList.add('is-error');add.disabled=false;}
      });
      if (!selected && !select) add.disabled=true;
      buttons?.prepend(add);
      body.appendChild(this.node('p','status',this.labels.disclaimer));
    }
    quiz(row,body,day) {
      body.appendChild(this.node('p','label',this.localized(row,'question') || this.labels.quiz));
      const options=['a','b','c'];
      const radioName='boker-quiz-'+this.dataset.blockId+'-'+day;
      const choices=this.node('div');body.appendChild(choices);
      for (const key of options) {
        const answer=this.localized(row,'answer_'+key);
        if(!answer)continue;
        const label=this.node('label','choice');
        const radio=document.createElement('input');radio.type='radio';radio.name=radioName;radio.value=key;
        label.appendChild(radio);label.appendChild(this.node('span',null,answer));choices.appendChild(label);
      }
      const feedback=this.node('p','status');feedback.setAttribute('role','status');
      const reward=this.node('div');reward.hidden=true;
      const check=this.button(this.labels.check,()=>{
        const selected=choices.querySelector('input:checked');
        if(!selected){feedback.textContent=this.labels.select;return;}
        if(selected.value===(row.correct_answer||'a').trim().toLowerCase()){
          feedback.textContent=this.labels.correct;
          if(row.bonus_code){reward.hidden=false;reward.replaceChildren();this.promoArea(reward,row.bonus_code);}
        } else {feedback.textContent=this.labels.wrong;reward.hidden=true;}
      });
      body.appendChild(check);body.appendChild(feedback);body.appendChild(reward);
    }
    deal(row,body,day) {
      const zone=this.node('div');body.appendChild(zone);
      const allPreview=this.testMode && this.testView === 'all';
      if (!allPreview && !this.todayIs(day)) {zone.appendChild(this.node('p','status',this.labels.expired));return;}
      const countdown=this.node('div','countdown');
      zone.appendChild(this.node('p','label',this.labels.dealend));zone.appendChild(countdown);
      // "All doors" gives every offer its own simulated action day; date mode uses one advancing calendar clock.
      const openedAt=performance.now();
      const simulatedStart=Date.UTC(this.year,11,day,this.testHour-1,0,0);
      const deadline=Date.UTC(this.year,11,day,23,0,0);
      const render=()=>{
        const now=allPreview ? simulatedStart+(performance.now()-openedAt) : this.now();
        const remaining=deadline-now;
        if (remaining<=0) {
          zone.replaceChildren(this.node('p','status',this.labels.expired));
          if (this.timer) {clearInterval(this.timer);this.timer=null;}
          this.refreshDoors();return false;
        }
        const seconds=Math.ceil(remaining/1000);
        countdown.textContent=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(':');
        return true;
      };
      if (this.timer) {clearInterval(this.timer);this.timer=null;}
      if (!render()) return;
      if (row.discount_code) this.promoArea(zone,row.discount_code);
      this.addLink(zone,row);
      this.timer=window.setInterval(render,1000);
    }
    video(row,body) {
      const src=this.safeURL(row.video_url);
      if(!src){body.appendChild(this.node('p','status',this.labels.noVideo));this.addLink(body,row);return;}
      const url=new URL(src);let embed=null;
      if(url.hostname==='youtu.be')embed='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(url.pathname.slice(1).split('/')[0]);
      else if(['www.youtube.com','youtube.com','m.youtube.com','www.youtube-nocookie.com','youtube-nocookie.com'].includes(url.hostname)){
        const id=url.searchParams.get('v') || url.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1];
        if(id && /^[\w-]{6,}$/.test(id))embed='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id);
      }else if(url.hostname==='vimeo.com'||url.hostname==='www.vimeo.com'){
        const id=url.pathname.match(/\/(\d+)/)?.[1];if(id)embed='https://player.vimeo.com/video/'+id;
      }else if(url.hostname==='player.vimeo.com')embed=src;
      if(embed){const iframe=this.node('iframe','player');iframe.src=embed;iframe.loading='lazy';iframe.title=this.labels.day;iframe.allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';iframe.allowFullscreen=true;body.appendChild(iframe);}
      else if(/\.mp4(?:\?|$)/i.test(src)){const player=this.node('video','player');player.controls=true;player.preload='metadata';player.src=src;body.appendChild(player);}
      else body.appendChild(this.node('p','status',this.labels.noVideo));
      this.addLink(body,row);
    }
    giveaway(row,body,day) {
      const terms=this.safeURL(row.terms_url);
      const external=this.safeURL(row.giveaway_form_url || row.link_url);
      if(!terms){body.appendChild(this.node('p','status',this.labels.giveawaymissing));return;}
      const mode=String(row.giveaway_mode||'external').toLowerCase();
      if(mode==='contact'){
        const template=this.querySelector('[data-giveaway-form-template]');
        const clone=template.content.cloneNode(true);
        if (this.testMode) {
          const form=clone.querySelector('form');
          // Even a direct form.submit() cannot post to Shopify from this preview form.
          form.action='about:blank';form.method='get';
          form.querySelectorAll('input').forEach(input=>input.removeAttribute('name'));
        }
        clone.querySelector('[data-giveaway-body]').value='Boker Adventskalender / '+this.year+' / Tuerchen '+day;
        clone.querySelector('[data-form-name-label]').textContent=this.labels.name;
        clone.querySelector('[data-form-email-label]').textContent=this.labels.email;
        clone.querySelector('[data-form-submit]').textContent=this.labels.giveaway;
        clone.querySelector('[data-no-newsletter]').textContent=this.labels.noNewsletter;
        const agree=clone.querySelector('[data-terms-text]');agree.textContent=this.labels.terms+' ';
        const termsLink=document.createElement('a');termsLink.href=this.testMode ? '#' : terms;termsLink.target='_blank';termsLink.rel='noopener';termsLink.textContent=this.labels.termslink;agree.appendChild(termsLink);
        const privacy=this.querySelector('[data-privacy-url]');
        if(privacy){const a=this.link(this.labels.privacy,privacy.dataset.privacyUrl);if(a){a.className='';agree.appendChild(document.createTextNode(' · '));agree.appendChild(a);}}
        body.appendChild(clone);
      }else if(external){
        const a=this.link(this.localized(row,'button')||this.labels.giveaway,external);if(a)this.group(body).appendChild(a);
        const p=this.node('p','status');const t=this.link(this.labels.termslink,terms);
        if(t){t.className='';t.target='_blank';t.rel='noopener';p.appendChild(t);}body.appendChild(p);
      }else body.appendChild(this.node('p','status',this.labels.giveawaymissing));
    }
  }
  customElements.define(tag,BokerAdventCSV);
  const calendarsIn = scope => {
    const found=[];
    if(scope?.matches?.(tag))found.push(scope);
    scope?.querySelectorAll?.(tag).forEach(el=>found.push(el));
    return found;
  };
  document.addEventListener('shopify:section:load',event=>{
    calendarsIn(event.target).forEach(el=>el.queueInitialize(true));
  });
  document.addEventListener('shopify:section:unload',event=>{
    calendarsIn(event.target).forEach(el=>el.cleanupRuntime());
  });
  document.addEventListener('shopify:block:select',event=>{
    calendarsIn(event.target).forEach(el=>el.queueInitialize());
  });
})();
  } catch(e) { console.error(e); }
})();

})();
